import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Subject } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { SubjectItem } from "../SubjectItem";

const subjectController = new Subject();

export function ListSubject(props) {
  const { reload, onReload } = props;
  const [subjects, setSubjects] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setSubjects(null);
        const response = await subjectController.getSubjects(accessToken);
        setSubjects(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, accessToken]);

  if (!subjects) return <Loader active inline="centered" />;
  if (size(subjects) === 0) return "No existen asignaturas registradas";

  return map(subjects, (subject) => (
    <SubjectItem key={subject.id} subject={subject} onReload={onReload} />
  ));
}
